import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { type Role, ROLES } from "@/api/admins";
import { getAdminStoreState } from "@/stores";

const AdminsLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/admins")({
  beforeLoad: () => {
    const { admin } = getAdminStoreState();

    const requiredPermissions: Role[] = [ROLES.super];

    if (!admin || !requiredPermissions.includes(admin.role)) {
      throw redirect({ to: "/$" });
    }
  },
  component: AdminsLayout,
});
